"use strict";
const stringParser = require('./stringParser');
const numberParser = require('./numberParser');
const dateParser = require('./dateParser');
const arrayOfStringParser = require('./arrayOfStringParser');
const parsers = [stringParser, numberParser, dateParser, arrayOfStringParser];
module.exports = (variable) => {
    const matchingParser = parsers.find(({ accepts }) => accepts(variable));
    if (!matchingParser) {
        throw new Error(`No parser found for valueType: ${variable.valueType}`);
    }
    const { parse } = matchingParser;
    return parse(variable);
};
//# sourceMappingURL=index.js.map